import { defineStore } from 'pinia';
import Artifacts from '@/roc/museum';
import ArtifactGroups from '@/roc/museum/base/ArtifactGroups';
import { computed, nextTick, ref, watch } from "vue";
export const useMuseumStore = defineStore('Museums', () => {
    const artifacts = ref({});
    const configuringMuseums = ref(false);
    const artifactMap = ref({});
    const groupMap = ref({});
    for (let i = 0; i < Artifacts.length; i++) {
        artifactMap.value[Artifacts[i].id] = {
            ...Artifacts[i]
        };
        artifacts.value[Artifacts[i].id] = {
            id: Artifacts[i].id,
            active: false
        };
    }
    for (let i = 0; i < ArtifactGroups.length; i++) {
        groupMap.value[ArtifactGroups[i].type] = {
            id: ArtifactGroups[i].type,
            name: ArtifactGroups[i].name,
            icon: ArtifactGroups[i].icon,
        };
    }
    const activeArtifactCount = computed(() => {
        let r = 0;
        for (const i in artifacts.value) {
            if (artifacts.value[i].active) {
                r++;
            }
        }
        return r;
    });
    const totalArtifactCount = computed(() => {
        return Artifacts.length;
    });
    const calculateCultureBonus = (config) => {
        const result = {
            value: 0,
            range: 1
        };
        for (const i in config) {
            if (config[i].active) {
                result.value += artifactMap.value[i].power;
            }
        }
        const grouped = {};
        for (const i in config) {
            if (!grouped[artifactMap.value[i].type]) {
                grouped[artifactMap.value[i].type] = [];
            }
            grouped[artifactMap.value[i].type].push(artifactMap.value[i]);
        }
        for (const i in grouped) {
            const allActive = grouped[i].every(item => config[item.id].active);
            if (allActive && result.range < 4) {
                result.range++;
            }
        }
        return result;
    };
    const cultureBonus = ref({
        value: 0,
        range: 1
    });
    watch(artifacts, () => {
        nextTick(() => {
            cultureBonus.value = calculateCultureBonus(artifacts.value);
        });
    }, { deep: true });
    return {
        // state
        artifacts,
        configuringMuseums,
        artifactMap,
        groupMap,
        // getters
        activeArtifactCount,
        totalArtifactCount,
        cultureBonus,
        // actions
        calculateCultureBonus,
        openMuseumConfiguration() {
            configuringMuseums.value = true;
        },
        closeMuseumConfiguration() {
            configuringMuseums.value = false;
        },
        setMuseumConfiguration(config) {
            artifacts.value = {
                ...config
            };
        },
        loadMuseumConfiguration(data) {
            for (let i = 0; i < data.length; i++) {
                artifacts.value[data[i].id] = {
                    ...data[i]
                };
            }
        }
    };
});
